
import { Phone } from "lucide-react";
import { Button } from "../ui/button";

export const NavbarPhoneButton = () => {
  const isMobile = window.innerWidth < 768;

  return (
    <Button
      variant="ghost"
      size="lg"
      asChild
      className={`bg-accent hover:bg-accent-hover text-accent-light transform hover:scale-110 transition-all duration-300 py-1.5 ${
        isMobile ? 'px-3' : 'px-6'
      } text-xs sm:text-sm md:text-base whitespace-nowrap animate-[wiggle_1s_ease-in-out_1s_7,wiggle_1s_ease-in-out_8s_7,wiggle_1s_ease-in-out_15s_7,wiggle_1s_ease-in-out_22s_7,wiggle_1s_ease-in-out_29s_7,wiggle_1s_ease-in-out_36s_7,wiggle_1s_ease-in-out_43s_7,wiggle_1s_ease-in-out_50s_7,wiggle_1s_ease-in-out_57s_7,wiggle_1s_ease-in-out_64s_7,wiggle_1s_ease-in-out_71s_7,wiggle_1s_ease-in-out_78s_7,wiggle_1s_ease-in-out_85s_7,wiggle_1s_ease-in-out_92s_7,wiggle_1s_ease-in-out_99s_7]`}
    >
      <a href="tel:18007939081" className="inline-flex items-center">
        <Phone className="h-4 w-4 sm:h-5 sm:w-5 mr-1 animate-pulse" />
        <span className="text-white font-bold">1-800-793-9081</span>
      </a>
    </Button>
  );
};
